import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { eAppContext, LoginInput, QueovalDik, GlobalParams, eLogMode, ConfigFile, eLoginStart } from '../models';
import { CoreService } from '../services';
import { HttpClient } from '@angular/common/http';
import { mergeMap, catchError } from 'rxjs/operators';
import { LoginExtranetService } from './common.login.srv.extranet';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CommonLoginService extends LoginExtranetService {

  constructor(
    protected indParam: CoreService,
    protected http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) { super(indParam, http); }


  getConfig(inputData: LoginInput): Observable<QueovalDik> {
    const mr: number = Math.random();
    switch (inputData.Context) {
      case eAppContext.LOGINEX:
        //#region app-login for Extranet
        return this.http.get<any>(`${inputData.configFilePath}?v=${mr}`).pipe(mergeMap((dataEX: any) => {
          this.indParam.AppParams = new GlobalParams(eAppContext.EXTRANET, dataEX.appUrl, dataEX.apiUrl);
          this.indParam.AppParams.loginMode = eLogMode.FULLANGULAR;
          // on affect la connexion a WS login suivant le fichier de config json
          this.indParam.AppParams.apiLogin = dataEX.apilogin;
          // on force la redirection pour le paramatrege dans le fichier de config json (si non renseigne il est retourné par le parametrage de dbconnect)
          this.indParam.AppParams.appLoginSite = dataEX.applogin;
          // pour l'authentification et acces au apiAuth
          this.indParam.AppParams.UrlAuthWS = dataEX.UrlAuthWS;
          // Cas particulier : Redirection depuis un QRCODE
          const qrparam: string | null = this.route.snapshot.queryParamMap.get('QRC');
          if (qrparam && qrparam !== '') {
            console.log(qrparam);
            this.indParam.showSplash(true);
            this.http.get<string>(`${this.indParam.AppParams.apiLogin}api/loginapp/extranet/getexlinkfromQR/${inputData.NameDB}/${qrparam}`).subscribe(
              (data: string) => {
                if (data) {
                  window.location.href = data;
                }
                this.indParam.showSplash(false);
              });

          }

          return this.getLogoDB(inputData.NameDB);
        }), catchError((error: Error) => {
          console.error(error ? JSON.stringify(error) : '');
          return of(new QueovalDik('ERROR', 'Erreur de lecture du fichier de configuration'));
        }));
      case eAppContext.LOGINEL:
        return this.http.get<any>(`${inputData.configFilePath}?v=${mr}`).pipe(mergeMap((dataEL: any) => {
          this.indParam.AppParams = new GlobalParams(eAppContext.ELEARNING, dataEL.appUrl, dataEL.apiUrl);
          this.indParam.AppParams.loginMode = eLogMode.NONE;
          // on affect la connexion a WS login suivant le fichier de config json
          this.indParam.AppParams.apiLogin = dataEL.apilogin;
          // on force la redirection pour le paramatrege dans le fichier de config json (si non renseigne il est retourné par le parametrage de dbconnect)
          this.indParam.AppParams.appLoginSite = dataEL.applogin;
          // pour l'authentification et acces au apiAuth
          this.indParam.AppParams.UrlAuthWS = dataEL.UrlAuthWS;
          return this.getLogoDB(inputData.NameDB);
        }), catchError((error: Error) => {
          console.error(error ? JSON.stringify(error) : '');
          return of(new QueovalDik('ERROR', 'Erreur de lecture du fichier de configuration'));
        }));
     
      case eAppContext.QUESTIONNAIRE:
        return this.http.get<any>(`${inputData.configFilePath}?v=${mr}`).pipe(mergeMap((dataQUEST: any) => {
          this.indParam.AppParams = new GlobalParams(inputData.Context, dataQUEST.appUrl, dataQUEST.apiUrl);
          this.indParam.AppParams.loginMode = eLogMode.NONE;
          // on affect la connexion a WS login suivant le fichier de config json
          this.indParam.AppParams.apiLogin = dataQUEST.apilogin;
          // on force la redirection pour le paramatrege dans le fichier de config json (si non renseigne il est retourné par le parametrage de dbconnect)
          this.indParam.AppParams.appLoginSite = dataQUEST.applogin;
          // pour l'authentification et acces au apiAuth
          this.indParam.AppParams.UrlAuthWS = dataQUEST.UrlAuthWS;

          switch (inputData.LoginStart) {
            case eLoginStart.PORTAIL:
              const us: string = inputData.getStorage('extranetuser');
              const ps: string = inputData.getStorage('extranetpswd');
              return this.LoginFromPortail(us, ps, inputData.NameDB, eAppContext.QUESTIONNAIRE);
            case eLoginStart.MAIL:
              const use: string = inputData.getStorage('usermail');
              const pse: string = inputData.getStorage('pswdmail');
              return this.mailLogin(use, pse, inputData.NameDB, inputData.Context);
            default:
              return of(new QueovalDik('OK', ''));
          }
        }), catchError((error: Error) => {
          console.error(error ? JSON.stringify(error) : '');
          return of(new QueovalDik('ERROR', 'Erreur de lecture du fichier de configuration'));
        }));
      
      case eAppContext.QUEOVAL:
        return this.http.get<any>(`${inputData.configFilePath}?v=${mr}`).pipe(mergeMap((dataERP: any) => {
          this.indParam.AppParams = new GlobalParams(inputData.Context, dataERP.appUrl, dataERP.apiUrl);
          // on affect la connexion a WS login suivant le fichier de config json
          this.indParam.AppParams.apiLogin = dataERP.apilogin;
          // on force la redirection pour le paramatrege dans le fichier de config json (si non renseigne il est retourné par le parametrage de dbconnect)
          this.indParam.AppParams.appLoginSite = dataERP.applogin;
          // le full angular enpeche la redirection sur pageconnection.aspx
          this.indParam.AppParams.loginMode = dataERP.mode == 'FULLANGULAR'  ? eLogMode.FULLANGULAR : eLogMode.MIXED;
          // pour l'authentification et acces au apiAuth
          this.indParam.AppParams.UrlAuthWS = dataERP.UrlAuthWS;
          if (inputData.NameDB && inputData.NameDB != '' && inputData.NameDB != 'METIER')
            return this.getLogoDB(inputData.NameDB);
          else
            return of(new QueovalDik('OK', ''));
        }), catchError((error: Error) => {
          console.error(error ? JSON.stringify(error) : '');
          return of(new QueovalDik('ERROR', 'Erreur de lecture du fichier de configuration'));
        }));
      default:
        return of(new QueovalDik('OK', ''));
    }
  }

  openView(routepath: string): void {
    this.router.navigate([routepath]);
  }

  private getLogoDB(db: string): Observable<QueovalDik> {
    if (db !== '') {
      return this.http.get<string>(`${this.indParam.AppParams.apiLogin}api/loginapp/getpicture/${db}`).pipe(mergeMap((result: string) => {
        if (result !== '') {
          //this.inputData.bigLogoUrl = result;
          //this.logoUrl = this.inputData.bigLogoUrl;
        }
        return of(new QueovalDik('OK', result));
      }), catchError((error: Error) => {
        console.error('Error getting logo DB: ');
        console.error(JSON.stringify(error));
        return of(new QueovalDik('ERROR', 'Erreur sur le retour du logo du client'));
      }));
    }
    return of(new QueovalDik('OK', '|'));
  }
}
